module.exports = function (fox) {
	'use strict';
	require('./stylus/_dialog.styl');
	require('jquery-ui/ui/dialog');
	require('./popupWidget');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/popupWidget/index.js
// module id = 495
// module chunks = 4